// extracted by css-extract-rspack-plugin
export default {"root":"CD3uu1","color-green":"TrHUrJ","colorGreen":"TrHUrJ","color-red":"mc7f0F","colorRed":"mc7f0F"};